import type { CSSProperties } from 'react';

export const ionContentVirtuosoStyle: CSSProperties = {
  position: 'absolute',
  inset: 0,
  height: 'auto',
};

export const IonContentVirtuosoTopInset: React.FC = () => (
  <div aria-hidden="true" style={{ height: 'var(--offset-top)' }} />
);

export const IonContentVirtuosoBottomInset: React.FC = () => (
  <div aria-hidden="true" style={{ height: 'var(--offset-bottom)' }} />
);
